import { Pipe, PipeTransform } from '@angular/core';
import { ContactInterface } from '@app/interfaces/contact.interface';

@Pipe({
    name: 'contactName',
})
export class ApplicantNameOrIndexByContactIdPipe implements PipeTransform {
    transform(contactId: string, applicants: ContactInterface[]): any {
        if (applicants?.length) {
            const applicantIndex = applicants.findIndex((a) => a._id === contactId);
            if (applicantIndex !== -1) {
                const applicant = applicants[applicantIndex];
                if (applicant && applicant.firstName && applicant.lastName) {
                    return `${applicant.firstName} ${applicant.lastName}`;
                } else {
                    return `Žadatel ${applicantIndex + 1}`;
                }
            }
        }
    }
}

@Pipe({
    name: 'applicantName',
})
export class ApplicantNameOrIndexByApplicantIdPipe implements PipeTransform {
    transform(contactId: string, contacts: ContactInterface[]): any {
        if (contacts?.length) {
            const contactIndex = contacts.findIndex((a) => a._id === contactId);
            if (contactIndex !== -1) {
                const contact = contacts[contactIndex];
                if (contact && contact.firstName && contact.lastName) {
                    return `${contact.firstName} ${contact.lastName}`;
                } else {
                    return `Žadatel ${contactIndex + 1}`;
                }
            }
        }
    }
}
